module.exports = __webpack_public_path__ + "img/9788992711586.1575eb8d.jpg";